import styled from 'styled-components';

export const CommunicationAreaSC = styled.div``;
